import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"border":"1px solid #ccc","border-radius":"18px","margin-top":"8px","padding":"6px"} }
const _hoisted_2 = { style: {"max-height":"80px","overflow":"scroll"} }
const _hoisted_3 = {
  key: 1,
  class: "tag-input-container"
}
const _hoisted_4 = { class: "score-filter" }
const _hoisted_5 = { class: "score-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-no-padding",
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  (!_ctx.isDemo)
                    ? (_openBlock(), _createBlock(_component_ion_buttons, {
                        key: 0,
                        slot: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            slot: "icon-only",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_searchbar, {
                    style: {"padding-bottom":"0","height":"28px"},
                    mode: "ios",
                    modelValue: _ctx.searchKeyword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        class: "no-text-transform",
                        target: "_blank",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" Score"),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("Input ")
                        ])),
                        _: 1,
                        __: [11]
                      }),
                      _createVNode(_component_ion_button, {
                        class: "no-text-transform",
                        href: `https://fdmt.hk/r/${_ctx.user.schoolId}`,
                        target: "_blank",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode(" Report ")
                        ])),
                        _: 1,
                        __: [12]
                      }, 8, ["href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (!_ctx.isAddingTag)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_ion_chip, {
                            class: _normalizeClass(["small-chip", { 'active-tag': _ctx.filters.custom.length == 0 }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleCustomFilter('All')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("All")
                                ])),
                                _: 1,
                                __: [13]
                              })
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserDefinedTags(), (tag) => {
                            return (_openBlock(), _createBlock(_component_ion_chip, {
                              key: tag.id,
                              class: _normalizeClass(["small-chip", { 'active-tag': _ctx.filters.custom.includes(tag.id) }]),
                              onClick: ($event: any) => (_ctx.toggleCustomFilter(tag.id))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "class"]))
                          }), 128)),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "clear",
                            class: "add-tag-btn",
                            color: "medium",
                            onClick: _ctx.startAddingTag
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "clear",
                            class: "add-tag-btn",
                            color: "medium",
                            onClick: _ctx.openManageTags
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.settingsOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            modelValue: _ctx.newTagName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTagName) = $event)),
                            placeholder: "New student group",
                            class: "tag-input",
                            onKeyup: _withKeys(_ctx.saveNewTag, ["enter"])
                          }, null, 8, ["modelValue", "onKeyup"]),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "clear",
                            onClick: _ctx.saveNewTag,
                            disabled: !_ctx.canSaveTag
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: _ctx.checkmark
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"]),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "clear",
                            onClick: _ctx.cancelAddingTag
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: _ctx.close
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                  ]),
                  _createVNode(_component_ion_segment, {
                    modelValue: _ctx.filters.yearDSE,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.yearDSE) = $event)),
                    mode: "ios",
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "all" }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("All")
                        ])),
                        _: 1,
                        __: [14]
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dseYears, (year) => {
                        return (_openBlock(), _createBlock(_component_ion_segment_button, {
                          key: year,
                          value: year
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("DSE " + _toDisplayString(year), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_segment, {
                    modelValue: _ctx.filters.studentClass,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.studentClass) = $event)),
                    mode: "ios",
                    scrollable: "",
                    style: {"margin-top":"2px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "all" }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("All")
                        ])),
                        _: 1,
                        __: [15]
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClasses(), (c) => {
                        return (_openBlock(), _createBlock(_component_ion_segment_button, {
                          key: c,
                          value: c
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(c), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_segment, {
                    modelValue: _ctx.filters.status,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.status) = $event)),
                    mode: "ios",
                    scrollable: "",
                    style: {"margin-top":"2px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "all" }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("All")
                        ])),
                        _: 1,
                        __: [16]
                      }),
                      _createVNode(_component_ion_segment_button, { value: "less-than-3-programs" }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Chose < 3 programs")
                        ])),
                        _: 1,
                        __: [17]
                      }),
                      _createVNode(_component_ion_segment_button, { value: "less-than-6-programs" }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("< 6 programs")
                        ])),
                        _: 1,
                        __: [18]
                      }),
                      _createVNode(_component_ion_segment_button, { value: "missing-target-scores" }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("Missing Target Scores")
                        ])),
                        _: 1,
                        __: [19]
                      }),
                      _createVNode(_component_ion_segment_button, { value: "complete" }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("Completed")
                        ])),
                        _: 1,
                        __: [20]
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.userRelatedSchool.achievejupasNeedParentConsent)
                    ? (_openBlock(), _createBlock(_component_ion_segment, {
                        key: 0,
                        modelValue: _ctx.filters.parentConsent,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.parentConsent) = $event)),
                        mode: "ios",
                        scrollable: "",
                        style: {"margin-top":"2px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment_button, { value: "all" }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("All")
                            ])),
                            _: 1,
                            __: [21]
                          }),
                          _createVNode(_component_ion_segment_button, { value: "yes" }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("Obtained parent consent")
                            ])),
                            _: 1,
                            __: [22]
                          }),
                          _createVNode(_component_ion_segment_button, { value: "no" }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode("Not yet obtained")
                            ])),
                            _: 1,
                            __: [23]
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_ion_select, {
                        interface: "popover",
                        mode: "ios",
                        class: "prediction-select",
                        value: "school"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "school" }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode("School Prediction")
                            ])),
                            _: 1,
                            __: [24]
                          }),
                          _createVNode(_component_ion_select_option, { value: "student" }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode("Student's Prediction")
                            ])),
                            _: 1,
                            __: [25]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_ion_range, {
                      color: "primary",
                      mode: "ios",
                      value: { lower: 18, upper: 25 },
                      min: 0,
                      max: 35,
                      "dual-knobs": true,
                      pin: true,
                      ticks: true
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { color: "primary" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        (_ctx.isAddingTag)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(Object.values(_ctx.selectedStudents).filter(v => v).length) + " student" + _toDisplayString(Object.values(_ctx.selectedStudents).filter(v => v).length > 1 ? 's' : '') + " selected", 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.getSortedStudents.length) + " student" + _toDisplayString(_ctx.getSortedStudents.length > 1 ? 's' : ''), 1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_buttons, {
                      slot: "end",
                      class: "sort-buttons"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          onClick: _ctx.toggleSortDirection
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              slot: "icon-only",
                              icon: _ctx.sortConfig.ascending ? _ctx.arrowUp : _ctx.arrowDown
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select, {
                      "aria-label": "Sort by",
                      slot: "end",
                      interface: "popover",
                      modelValue: _ctx.sortConfig.field,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sortConfig.field) = $event)),
                      placeholder: "Sort by",
                      class: "sort-select"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "class" }, {
                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createTextVNode("Class")
                          ])),
                          _: 1,
                          __: [26]
                        }),
                        _createVNode(_component_ion_select_option, { value: "studentNumber" }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createTextVNode("Student No.")
                          ])),
                          _: 1,
                          __: [27]
                        }),
                        _createVNode(_component_ion_select_option, { value: "fullName" }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode("Name")
                          ])),
                          _: 1,
                          __: [28]
                        }),
                        _createVNode(_component_ion_select_option, { value: "completion" }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode("Completion")
                          ])),
                          _: 1,
                          __: [29]
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-no-padding",
          fixed: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedStudents, (student, idx) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: idx,
                lines: "full",
                onClick: ($event: any) => (_ctx.isAddingTag ? undefined : _ctx.openUserDetails(student)),
                button: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_checkbox, {
                    "aria-label": "Select student",
                    slot: "start",
                    modelValue: _ctx.selectedStudents[student.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.selectedStudents[student.id]) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                    [_vShow, _ctx.isAddingTag]
                  ]),
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(student.class) + _toDisplayString(_ctx.formatStudentNumber(student.studentNumber)) + " " + _toDisplayString(student.fullName) + " ", 1),
                        (student.chineseName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(student.chineseName) + ")", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  (_ctx.userRelatedSchool.achievejupasNeedParentConsent)
                    ? (_openBlock(), _createBlock(_component_ion_chip, {
                        key: 0,
                        class: "small-chip",
                        color: _ctx.hasParentConsent(student) ? 'success' : 'danger'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            size: "small",
                            icon: _ctx.hasParentConsent(student) ? _ctx.checkmark : _ctx.close
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("Consent")
                            ])),
                            _: 1,
                            __: [30]
                          })
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : _createCommentVNode("", true),
                  (_ctx.getStudentProgramCount(student) >= 20)
                    ? (_openBlock(), _createBlock(_component_ion_badge, {
                        key: 1,
                        color: "primary"
                      }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("Complete")
                        ])),
                        _: 1,
                        __: [31]
                      }))
                    : (_openBlock(), _createBlock(_component_ion_badge, {
                        key: 2,
                        color: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getStudentProgramCount(student)) + "/20", 1)
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_modal, {
          "is-open": _ctx.isManagingTags,
          onDidDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isManagingTags = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_title, null, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("Manage Tags")
                      ])),
                      _: 1,
                      __: [32]
                    }),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isManagingTags = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.close
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserDefinedTags(), (tag) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: tag.id,
                        lines: "full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name) + " (" + _toDisplayString(_ctx.getNumOfStudentsOfTag(tag.id)) + ") ", 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            onClick: ($event: any) => (_ctx.editTag(tag))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: _ctx.createOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            color: "danger",
                            onClick: ($event: any) => (_ctx.deleteTag(tag))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: _ctx.trashOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    })
  ], 64))
}